import { apiRequest } from "../utils/http.js";

export async function listActiveCampuses() {
  return (await apiRequest("api/campuses/active")) || [];
}
